'use client'
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  getProductCardQuery
} from "./chunk-QPUNJKQ3.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  gqlClient
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/product/listing.ts
import { gql } from "graphql-request";
import {
  useInfiniteQuery,
  useQuery
} from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getProductListing($lang: String, $limit: Int, $skip: Int, $where: ProductFilter, $order: [ProductOrder]) {
  productCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {${getProductCardQuery()}}
  }
}
`;
var getProductListing = (props) => __async(null, null, function* () {
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({}, props), {
      lang: getContentfulSafeLocale(props.lang),
      where: __spreadValues(__spreadValues({}, commonWhere), props.where)
    }));
    return __spreadProps(__spreadValues({}, res.productCollection), {
      settledAt: Date.now()
    });
  } catch (error) {
    throw new Exception({ error, name: "getProductListingException" });
  }
});
var useGetProductsList = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getProductsList", props],
    queryFn: () => getProductListing(props)
  }));
};
var useGetInfiniteProductsList = (props, options) => {
  const perPage = props.perPage || props.limit || 10;
  return useInfiniteQuery(__spreadValues({
    queryKey: ["getInfiniteProductsList", props],
    queryFn: (_0) => __async(null, [_0], function* ({ pageParam = 1 }) {
      return getProductListing(__spreadProps(__spreadValues({}, props), { limit: perPage, skip: (pageParam - 1) * perPage }));
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const current = lastPageParam || 1;
      const totalRendered = current * perPage;
      return lastPage.total > totalRendered ? current + 1 : void 0;
    },
    select: (data) => data.pages.flatMap((page) => page.items)
  }, options));
};

export {
  getProductListing,
  useGetProductsList,
  useGetInfiniteProductsList
};
//# sourceMappingURL=chunk-EZ7QK247.mjs.map